var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.carrierData)?_c('div',{staticClass:"full-height-layout fill"},[_c('mercur-card',[_c('carrier-service-level-list',{attrs:{"carrier-id":_vm.$route.params.carrierId,"carrier-data":_vm.carrierData}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }